import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="space-y-8 py-12 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Quick Links</h3>
            <div className="flex flex-col space-y-2 text-sm text-gray-300">
              <Link to="/calculator" className="hover:text-primary transition-colors duration-200">Debt Calculator</Link>
              <Link to="/register" className="hover:text-primary transition-colors duration-200">Register Now</Link>
              <Link to="/login" className="hover:text-primary transition-colors duration-200">Client Portal</Link>
            </div>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Legal</h3>
            <div className="flex flex-col space-y-2 text-sm text-gray-300">
              <Link to="/terms" className="hover:text-primary transition-colors duration-200">Terms & Conditions</Link>
              <Link to="/privacy" className="hover:text-primary transition-colors duration-200">Privacy Policy</Link>
              <Link to="/disclaimer" className="hover:text-primary transition-colors duration-200">Legal Disclaimer</Link>
            </div>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Contact</h3>
            <div className="text-sm text-gray-300 space-y-2">
              <p>Registered South African Law Firm</p>
              <p>Over 15 Years of Excellence</p>
            </div>
          </div>
        </div>
        
        <div className="text-sm text-gray-400 text-center pt-8">
          <p>© 2024 Tradeco Legal Services. All rights reserved.</p>
          <p className="mt-2 text-xs">
            A debt reduction is based on the performance of the debt solutions administered by our expert legal team. 
            Results may vary from person to person. A reduction in monthly debt repayments depends on the individual's 
            circumstances and the successful completion of the chosen solution.
          </p>
        </div>
      </div>
    </footer>
  );
};